import { Box, capitalize, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import ImageIcon from '@mui/icons-material/Image';
import IconButton from '@mui/material/IconButton';
import { Order, Shipment } from '../../../Models';
import { stateMapping } from '../../../utils/shipmentStateMapping';

export default function ShippingInfoSection({
    order,
    shipment,
}: {
    order: Order;
    shipment: Shipment | undefined;
}) {
    const formatDetails = () => {
        if (!shipment?.parcels[0]?.status) return '';

        const details = shipment.parcels
            .map((parcel) => {
                if (!parcel?.status) return [];

                const parcelDetails = [];

                if (parcel.status.failure_reason)
                    parcelDetails.push(`Fallo: ${parcel.status.failure_reason}`);
                if (parcel.status.delivery_attempt?.id_proof_of_delivery) {
                    const pod = parcel.status.delivery_attempt.id_proof_of_delivery;
                    parcelDetails.push(
                        `Receptor: ${pod.recipient_name} (${pod.recipient_id_number})`,
                    );
                }
                if (parcel.status.delivery_attempt?.comment_proof_of_delivery) {
                    parcelDetails.push(
                        `Comentario: ${parcel.status.delivery_attempt.comment_proof_of_delivery.comment}`,
                    );
                }
                if (parcel.status.delivery_attempt?.fail_reason)
                    parcelDetails.push(
                        `Razón de fallo: ${parcel.status.delivery_attempt.fail_reason}`,
                    );
                if (parcel.status.delivery_attempt?.support_ticket)
                    parcelDetails.push(`Ticket: ${parcel.status.delivery_attempt.support_ticket}`);
                if (parcel.status.delivery_attempt?.feedback)
                    parcelDetails.push(`Feedback: ${parcel.status.delivery_attempt.feedback}`);
                if (parcel.status.pickup_attempt) {
                    if (parcel.status.pickup_attempt.fail_reason)
                        parcelDetails.push(
                            `Fallo pickup: ${parcel.status.pickup_attempt.fail_reason}`,
                        );
                    if (parcel.status.pickup_attempt.feedback)
                        parcelDetails.push(
                            `Feedback pickup: ${parcel.status.pickup_attempt.feedback}`,
                        );
                    if (parcel.status.pickup_attempt.comment_proof_of_pickup?.comment)
                        parcelDetails.push(
                            `Comentario pickup: ${parcel.status.pickup_attempt.comment_proof_of_pickup.comment}`,
                        );
                }
                return parcelDetails;
            })
            .flat();

        return details.join('\n');
    };

    const hasPhotoUrl =
        shipment?.parcels[0]?.status?.delivery_attempt?.photo_proof_of_delivery?.photo_url ||
        shipment?.parcels[0]?.status?.pickup_attempt?.photo_proof_of_pickup?.photo_url;

    return (
        <Box>
            <Typography variant="subtitle1" gutterBottom>
                🛵 Envío
            </Typography>
            <Grid container spacing={1} alignItems="center">
                <Grid md={3}>
                    <Typography variant="body2" color="textSecondary">
                        A cargo
                    </Typography>
                    <Typography variant="body1">
                        {shipment?.parcels[0]?.status?.tracking?.tracking_url ? (
                            <a
                                href={shipment.parcels[0].status.tracking.tracking_url}
                                target="_blank"
                                rel="noopener noreferrer">
                                {capitalize(shipment.courier)}
                            </a>
                        ) : (
                            capitalize(shipment?.courier || '')
                        )}
                    </Typography>
                </Grid>
                <Grid md={3}>
                    <Typography variant="body2" color="textSecondary">
                        Estado
                    </Typography>
                    <Typography variant="body1">
                        {shipment?.state ? stateMapping[shipment?.state] : ''}
                    </Typography>
                </Grid>
                <Grid md="auto" xs={12}>
                    <Typography variant="body2" color="textSecondary">
                        Dirección
                    </Typography>
                    <Typography variant="body1">
                        {shipment?.parcels[0]?.dropoff_info.addr}
                    </Typography>
                </Grid>
                <Grid xs={12}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography variant="body1" sx={{ whiteSpace: 'pre-line' }}>
                            {formatDetails()}
                        </Typography>
                        {hasPhotoUrl && (
                            <IconButton
                                size="small"
                                onClick={() => window.open(hasPhotoUrl, '_blank')}>
                                <ImageIcon fontSize="small" />
                            </IconButton>
                        )}
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}
